module.exports = __webpack_public_path__ + "img/power-switch-electricity-loop.46573f44.png";